import { TableLink } from "components/BaseTableV3/TableLink";

// A related record that is not stored locally has no name, so it gets no link.
export const linkCell =
  toHref =>
  ({ row, getValue }) => {
    const value = getValue();
    return value == null ? null : (
      <TableLink href={toHref(row.original)}>{value}</TableLink>
    );
  };
